import React from "react";
import { Dialog, Box, Button } from "@material-ui/core";
import { Trans } from "@lingui/macro";
import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";
import { isMobile } from "../../utils";
import SecondaryButton from "../secondary-button";
import FullInfo from "./full-info";
import CloseIcon from "../../icons/close-icon";

const useStyles = makeStyles((th) => ({
  modal: {
    paddingTop: isMobile() ? th.spacing(4) : th.spacing(2),
    paddingLeft: th.spacing(4),
    paddingRight: th.spacing(4),
  },
  closeIcon: {
    position: "absolute",
    right: "20px",
    top: "15px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    paddingRight: theme.spacing(4),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      backgroundColor: theme.palette.white,
      position: "fixed",
      width: "100%",
      bottom: 0,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
      boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.1)",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
    },
  },
}));

const CookiesModal = ({ onClose, open, rejectCookies }) => {
  const classes = useStyles({ theme });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableScrollLock
      fullScreen={isMobile()}
      PaperProps={{
        style: {
          display: "flex",
          flexDirection: "column",
          width: "650px",
          maxWidth: "650px",
          maxHeight: isMobile() ? "100%" : "520px",
          borderRadius: isMobile() ? "0px" : "10px",
        },
      }}
    >
      <Box onClick={onClose} className={classes.closeIcon}>
        <Box style={{ cursor: "pointer" }}>
          <CloseIcon width="16px" height="16px" />
        </Box>
      </Box>
      <Box className={classes.modal}>
        <Box>
          <FullInfo />
        </Box>
      </Box>
      <Box className={classes.buttonContainer}>
        <SecondaryButton onClick={() => rejectCookies()}>
          <Trans>Rechazar todo</Trans>
        </SecondaryButton>
        <Button onClick={onClose} variant="contained" color="primary">
          <Trans>Aceptar</Trans>
        </Button>
      </Box>
    </Dialog>
  );
};

export default CookiesModal;
